// @flow
import { handleActions } from 'redux-actions';

import {
  REGISTER_OWNER,
  REGISTER_OWNER_SUCCESS,
  REGISTER_OWNER_FAILURE,
} from '../../actions/actionTypes';

const initialState = {
  error: '',
  errorCode: undefined,
  success: false,
};

export const requests = handleActions(
  {
    [REGISTER_OWNER]: state => (
      {
        ...state,
        // Reset the request state everytime we hit it another time
        ...initialState,
      }
    ),
    [REGISTER_OWNER_SUCCESS]: state => (
      {
        ...state,
      }
    ),
    [REGISTER_OWNER_FAILURE]: (state, action) => (
      {
        ...state,
        error: action.payload.error,
        errorCode: action.payload.error_code,
        success: action.payload.success,
      }
    ),
  },
  initialState,
);
